export const getOurDealStage = (dealstage: string) => {
  if (dealstage === 'closedwon') return 'active';
  if (dealstage === 'presentationscheduled') return 'connection scheduled';
  if (dealstage === 'closedlost') return 'cancelled';
  if (dealstage === '21134691') return 'provisioning only';
  return dealstage;
};
